import axios from "axios";

export default () => {

    const instance = axios.create({
        baseURL: 'https://cms.aliff.in/api'
    });

    instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    instance.defaults.headers.common["Authorization"] = "Bearer 7616db2dea245547fd1f5e5e6292026a59e9fe45951ec0cfd22e78076bf7b676bcb7e3af7033127dd26e019c80e21ba96a8b5a89b8910fbbe1cf154a532e2f35aa270558c7ff354f81d9afdddce50b6e50940a9f6b2ac601acb47184f45a34382f0154146a253078c3b23a7c1dbb9789b25332d1001c21ea79e9e07e67d9fa85";

    return instance;
};



// WEBPACK FOOTER //
// ./src/apiServices/StrapiApi.js